// extracted by mini-css-extract-plugin
module.exports = {"frame":"Timeline_frame__3wGDe","series":"Timeline_series__2snNc","xAxis":"Timeline_xAxis__1cmDY","yAxis":"Timeline_yAxis__3u3Bw"};